export enum ChatMessageRole {
  User = 0,
  Assistant = 1,
  Tool = 2,
}
